import React, { FC } from 'react';
import styled from 'styled-components';
import { PageHeading } from '../../components/page-heading/page-heading';
import { IProductAvailability } from '../../graphql/types';
import { Black1, Grey2, White, White2 } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';
import { PlantDropDown } from './alternate-plants/plant-dropdown';
import { ProductAvailabilityTile } from './product-availability-tile';
import { StockDetails } from './stock-details';
import { PlantDetails } from './table/plant-details';
import { ProductAvailabilityTable } from './table/table';

const StyledProductAvailabilitySection = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledTopSection = styled.div`
  background-color: ${White};
  padding: 3rem 0rem 3.5rem 7.5rem;
`;

const StyledBottomSection = styled.div`
  padding: 6.5rem 7.5rem 4.5rem 7.5rem;
`;

const StyledTableHeading = styled.span`
  background: ${White2};
  font-size: 1.5rem;
  font-family: ${DemiBold};
  color: ${Black1};
`;

const StyledContainer = styled.div`
  padding: 1.5rem 1rem 1.5rem 1rem;
  border-radius: 0.25rem;
  background-color: ${White};
  margin-top: 2rem;
`;

const StyledRow = styled.div`
  background-color: ${White2};
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem 1.5rem 2rem;
`;

const StyledPlantContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledTitle = styled.span`
  color: ${Grey2};
  font-size: 0.875rem;
  font-family: ${DemiBold};
  padding: 0.6rem 0.3rem 0rem 1.25rem;
`;

export const ProductAvailabilityBody: FC<{
  shipToId: string;
  productAvailability: IProductAvailability;
}> = ({ shipToId, productAvailability }) => {
  return (
    <StyledProductAvailabilitySection>
      <StyledTopSection>
        <PageHeading>Product availability</PageHeading>
        <ProductAvailabilityTile
          shipToId={shipToId}
          productAvailability={productAvailability}
        />
      </StyledTopSection>
      <StyledBottomSection>
        <StyledTableHeading>Material details</StyledTableHeading>
        <StyledContainer>
          <StyledRow>
            <StyledPlantContainer>
              <PlantDetails productAvailability={productAvailability} />
              <StyledTitle>Standard search:</StyledTitle>
              <PlantDropDown
                productAvailability={productAvailability}
                shipToId={shipToId}
                productId={productAvailability.product.id}
                isExtended={false}
              />
              <StyledTitle>Extended plant search:</StyledTitle>
              <PlantDropDown
                productAvailability={productAvailability}
                shipToId={shipToId}
                productId={productAvailability.product.id}
                isExtended={true}
              />
            </StyledPlantContainer>
            <StockDetails stock={productAvailability.transactions[0]} />
          </StyledRow>
        </StyledContainer>
        <ProductAvailabilityTable productAvailability={productAvailability} />
      </StyledBottomSection>
    </StyledProductAvailabilitySection>
  );
};
